import type { SobActualsReviewPayload } from '../api/applySobActualsReview'
import { OVERALL_SUB_CATEGORY } from '../model/constants'
import type { SobInputState, SobTableEntry } from '../model/types'

export const buildSobActualsReviewPayload = ({
  entries,
  pid,
  currentFiscalYear,
  offering,
  category,
  getEntryInputs,
  getEntryNoPlan,
  getEntryNoPlanContractual,
}: {
  entries: SobTableEntry[]
  pid: string
  currentFiscalYear: number
  offering: string
  category: string | null
  getEntryInputs: (entry: SobTableEntry) => SobInputState
  getEntryNoPlan: (entry: SobTableEntry) => boolean
  getEntryNoPlanContractual: (entry: SobTableEntry) => boolean
}): SobActualsReviewPayload[] =>
  entries.map((entry) => {
    const entryInputs = getEntryInputs(entry)

    return {
      PartnerId: pid,
      FYear: currentFiscalYear,
      ProgramTypes: offering,
      Category: category ?? entry.rows[0]?.Category ?? OVERALL_SUB_CATEGORY,
      SubCategory: entry.subCategory,
      L3Category: entry.l3Category ?? OVERALL_SUB_CATEGORY,
      IsNoPlan: !entry.isOverall && getEntryNoPlan(entry) ? 1 : 0,
      IsNoPlanContractual: !entry.isOverall && getEntryNoPlanContractual(entry) ? 1 : 0,
      SobActualPYQ1: entryInputs.prevActuals.q1,
      SobActualPYQ2: entryInputs.prevActuals.q2,
      SobActualPYQ3: entryInputs.prevActuals.q3,
      SobActualPYQ4: entryInputs.prevActuals.q4,
      SobActualCYQ1: entryInputs.currentActuals.q1,
      SobActualCYQ2: entryInputs.currentActuals.q2,
      SobActualCYQ3: entryInputs.currentActuals.q3,
      SobActualCYQ4: entryInputs.currentActuals.q4,
    }
  })
